module.exports = __webpack_public_path__ + "img/Most-Critical@2x.c054389c.png";